module.exports = __webpack_public_path__ + "static/media/Frame2.4.48525cc7.svg";